export default __webpack_public_path__ + "static/51983-d77f455b7093b0f3e95dd44da62fe7f5.jpg";